import { render, staticRenderFns } from "./AllergensConfiguration.vue?vue&type=template&id=48455b72&scoped=true"
import script from "./AllergensConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllergensConfiguration.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AllergensConfiguration.vue?vue&type=style&index=0&id=48455b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48455b72",
  null
  
)

export default component.exports